import * as API from '../api'
export const FETCH_LABORATORY = 'FETCH_LABORATORY'
export const FETCHING_LABORATORY = 'FETCHING_LABORATORY'
export const FETCH_LABORATORY_ERROR = 'FETCH_LABORATORY_ERROR'
export const FETCH_LABORATORIES = 'FETCH_LABORATORIES'
export const FETCH_LABORATORIESALL = 'FETCH_LABORATORIESALL'
export const FETCHING_LABORATORIES = 'FETCHING_LABORATORIES'
export const FETCH_LABORATORIES_ERROR = 'FETCH_LABORATORIES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_LABORATORY = 'CHANGE_LABORATORY'
export const DELETE_LABORATORY = 'DELETE_LABORATORY'
export const ADD_LABORATORY = 'ADD_LABORATORY'
export const EDIT_LABORATORY = 'EDIT_LABORATORY'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_LABORATORY = 'NEW_FORM_LABORATORY'
export const LABORATORY_FORM_ERROR = 'LABORATORY_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeLaboratory = laboratory => {
  return dispatch => {
    dispatch({ type: CHANGE_LABORATORY, laboratory })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleLaboratoryError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: LABORATORY_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormLaboratory = laboratory => {
  return dispatch => {
    dispatch({ type: NEW_FORM_LABORATORY })
  }
}

export const setLaboratoryFormTouched = laboratory => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreLaboratory = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORIES })
    return API.laboratories
      .restoreLaboratory(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_LABORATORY, laboratory: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_LABORATORIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleLaboratoryError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchLaboratoriesAll = () => {
  return dispatch => {
    API.laboratories.getLaboratoriesAll().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_LABORATORIESALL, laboratories: data })
    })
  }
}

export const fetchLaboratories = options => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORIES })
    return API.laboratories
      .getLaboratories(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_LABORATORIES,
          laboratories: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_LABORATORIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteLaboratory = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORIES })
    return API.laboratories
      .deleteLaboratory(id)
      .then(({ data: laboratory }) => {
        dispatch({ type: DELETE_LABORATORY, laboratory })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_LABORATORIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addLaboratory = laboratory => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORIES })
    dispatch({ type: FETCHING_LABORATORY })
    return API.laboratories
      .addLaboratory(laboratory)
      .then(({ data }) => {
        dispatch({ type: ADD_LABORATORY, laboratory: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleLaboratoryError(response, dispatch)
        dispatch({
          type: FETCH_LABORATORIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editLaboratory = laboratory => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORIES })
    dispatch({ type: FETCHING_LABORATORY })
    return API.laboratories
      .editLaboratory(laboratory)
      .then(({ data }) => {
        dispatch({ type: EDIT_LABORATORY, laboratory: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_LABORATORIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleLaboratoryError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchLaboratory = id => {
  return dispatch => {
    dispatch({ type: FETCHING_LABORATORY, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.laboratories
      .getLaboratory(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_LABORATORY, laboratory: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_LABORATORY_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/laboratories.js